import React, { useEffect, useState } from 'react';
import { Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  Container,
  Grid,
} from '@material-ui/core';
import { useHistory } from "react-router-dom";
import useReactRouter from 'use-react-router';
import { Button as Buttonh } from '@material-ui/core';
import { green } from "@material-ui/core/colors";
import { TextField } from '@material-ui/core';
import HeaderMenu from '../../Components/Header/headeradmission';
import AdmissionMenu from '../../Components/Header/alumnimenu';
import Viewfield from '../../Components/FormsUI/Viewfield';
import { Button as Submit } from '@material-ui/core';
import nophoto from "./nophoto.jpg";

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(8),
  },
  root: {
    color: green[900],
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgba(0, 0, 0, 0.23)" // default
      },
      "&.Mui-focused fieldset": {
        border: "1px solid #C4C4C4" // customized
      }
    }
  }
}));



const PaymentAlumni = () => {

  const { match } = useReactRouter();

  const [instInfo, setinstInfo] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      let res = await fetch(`https://api.shebashikkha.com/public/online-applicantion/institute-info/${match.params.id}`)
      let data = await res.json()
      setinstInfo(data?.item)
    }
    fetchData();
  }, []);

  const [textid, settextid] = useState();
  const [payId, setpayId] = useState();
  const history = useHistory();

  const [data, setdata] = useState(null);


  async function formSubmit(e) {
    e.preventDefault();
    try {
      const rawResponse = await fetch(`${process.env.REACT_APP_API_ROOT}/public/alumni/student/view?instituteId=${match.params.id}&applicantId=${textid}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        // body: JSON.stringify(submit)
      });
      if (rawResponse.status === 201 || rawResponse.status === 200) {
        const content = await rawResponse.json();
        if (content?.messageType === 1) {
          setdata(content?.item)
          setpayId(content?.item?.alumniId)
        } else {
          alert("No Data Found");
          setdata(null);
        }

      } else {
        alert("Something went wrong");

      }

    }
    catch (err) {
      // not jumping in here.
      console.log(err)
    }
  }

  async function makePayment() {

    try {
      const rawResponse = await fetch(`${process.env.REACT_APP_API_ROOT}/public/get/alumni-application-payment/spg/session-id?alumniId=${payId}&instituteId=${parseInt(match.params.id)}`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        // body: JSON.stringify(submit)
      });
      if (rawResponse.status === 201 || rawResponse.status === 200) {
        const content = await rawResponse.json();
        if (content?.messageType === 1) {
          window.open('https://api.shebashikkha.com/public/goto/alumni-application-payment/portal?sessiontoken=' + content?.item);
        } else {
          alert(content?.message);
        }

      } else {
        alert("Something went wrong");

      }

    }
    catch (err) {
      // not jumping in here.
      console.log(err)
    }
  }




  return (
    <Grid container>
      <Grid item xs={12}>
        <HeaderMenu details={{ instituteName: instInfo?.institutename, address: instInfo?.instituteaddress, image: instInfo?.imageLink }} />
      </Grid>

      <Grid item xs={12} style={{ background: "#fff", boxShadow: "rgb(216 216 216) 0px 0px 15px 0px", padding: "15px" }}>

        <Divider />
        <AdmissionMenu />
        <br />
        <Grid item xs={12}>
          <Typography style={{ fontSize: "24px", textAlign: "center", marginBottom: "10px", color: "#f68b1f", fontWeight: "500" }}>
            Payment
          </Typography>
        </Grid>
        <br />
        <Divider />
        <br />
        <Grid item xs={12}>
          <Container maxWidth="md">
            <form onSubmit={formSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField id="outlined-basic" label="Applicant Id" variant="outlined" fullWidth required type="number" onChange={(e) => settextid(e.target.value)} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Buttonh type="submit" color="primary" variant="contained" fullWidth style={{ height: 55, backgroundColor:"#f68b1f"}}> Search</Buttonh>
                </Grid>
              </Grid>
            </form>
            <br></br><br />
            {data !== null &&
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                <div >
                <Typography style={{fontWeight:"bold"}} >Photo</Typography>
                </div>
                {data?.applicantImageName===null?
                <img src={nophoto} alt=" Photo" style={{ height: 90, width: 90, borderRadius: 45 }} />:
                <img src={data?.imageLink} alt=" Photo" style={{ height: 90, width: 90, borderRadius: 45 }} />
                }
                </Grid>


                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Applicant Name"
                    name={data?.applicantName}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Application Fee"
                    name={data?.applicationFee}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Service Charge"
                    name={data?.serviceCharge}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Number Of Guest"
                    name={data?.numberOfGuest}
                  />
                </Grid>                
                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Guest Amount"
                    name={data?.guestAmount}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Payable Amount"
                    name={data?.payableAmount}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Payment Status"
                    name={data?.paymentStatusString}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Paid Amount"
                    name={data?.paidAmount}
                  />
                </Grid>
                
                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Gender"
                    name={data?.gender}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Religion"
                    name={data?.religion}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Date of Birth"
                    name={data?.dob}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Father Name"
                    name={data?.fatherName}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Mother Name"
                    name={data?.motherName}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Class Name"
                    name={data?.className}
                  />
                </Grid>
 
                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Last Academic Year"
                    name={data?.lastAcademicYear}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Last Exam"
                    name={data?.lastExam}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Last Exam Year"
                    name={data?.lastExamYear}
                  />
                </Grid>


                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Contact No"
                    name={data?.contactNo}
                  />
                </Grid>
               
                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Email"
                    name={data?.email}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Apply Date"
                    name={data?.applyDate}
                  />
                </Grid>
                
                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Mailing Address"
                    name={data?.mailingAddress}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="Thana"
                    name={data?.presentThana}
                  />
                </Grid>                
                
                <Grid item xs={12} sm={4}>
                  <Viewfield
                    label="District"
                    name={data?.presentDistrict}
                  />
                </Grid>                
                <Grid item xs={12} sm={8}>

                </Grid>
                <Submit style={{backgroundColor:"#f68b1f" }} color='primary' variant="contained" onClick={() => makePayment()} >
                    Make Payment
                  </Submit>
                  
              </Grid>
            }

          </Container>

        </Grid>

      </Grid>
    </Grid>
  );
};

export default PaymentAlumni;
